(function($, Drupal) {
  'use strict';

  /*inicializamos scripts para que cargen en cuando finalice la carga del DOM */
  $(document).ready(function() {

    // Inicialización de tooltips. Ej: gráficas de créditos
    $('[data-toggle="tooltip"]').tooltip();

    // Activación de popovers para página de ventajas
    // Activación para resicendial
    $('#ventajas-content [data-toggle="popover"]').popover();

    /* --------------------------------------------------------------- */
    /* --------------------------------------------------------------- */
    /* --------------------------------------------------------------- */

    // Cambiar el modo del buscador entre lista, lista-full y grid
    $('.filtros-resultado-settings a').click(function(){
      let modo = $(this).data("mode");
      $('.filtros-resultado').removeClass("mode-list mode-list-full mode-grid");
      $('.filtros-resultado').addClass(modo);
    });

    /*
      Script para buscar por nombre los servicios de la universidad.
      Buscamos por nombre y
     */

    //$('#service-input-search').focus();
    listFilterServicios($('#service-input-search') , $('.listado-servicios'));
    function listFilterServicios(input, list) {
      $(input)
        .change(function() {
          var filter = quitAcentos($(this).val()).toLowerCase();
          $.each(list.find('.views-field-title h2'), function(index, val) {
            var textName = $(this).children('a').text();
            //console.log(textName);
            textName = quitAcentos(textName).toLowerCase();
            if ( textName.search(filter) != -1 )  {
              $(this).parent().parent().show();
            } else {
              $(this).parent().parent().hide();
            }
            var numberBox = $('.service-container').length;
            var numberBoxHidden = $('.service-container:hidden').length;
            if(numberBox == numberBoxHidden){
              $('#textNotFound').show();
            }else{
              $('#textNotFound').hide();
            }
          });
        })
        .keyup(function() {
          // fire the above change event after every letter
          $(this).change();
        });
    }

    //Buscador para profesorado
    listFilterProfesorado($('#faculty-input-search') , $('#profesorado'));
    function listFilterProfesorado(input, list) {
      $(input)
        .change(function() {
          var filter = quitAcentos($(this).val()).toLowerCase();
          // Ocultamos los títulos de grupo para que no molesten
          if(filter != ""){
            $('#profesorado h3').parent().parent().hide();
          }else{
            $('#profesorado h3').parent().parent().show();
          }
          $.each(list.find('.ficha-profesor__contacto .profesor__nombre'), function(index, val) {
            var textName = $(this).text();
            //console.log(textName);
            textName = quitAcentos(textName).toLowerCase();
            if ( textName.search(filter) != -1 )  {
              $(this).parent().parent().parent().show();
            } else {
              $(this).parent().parent().parent().attr("style", "display: none !important");
            }
            var numberBox = $('.ficha-profesor').length;
            var numberBoxHidden = $('.ficha-profesor:hidden').length;
            if(numberBox == numberBoxHidden){
              $('#textNotFound').show();
            }else{
              $('#textNotFound').hide();
            }
          });
        })
        .keyup(function() {
          // fire the above change event after every letter
          $(this).change();
        });
    }

    //BUSCADOR PARA PORTAL DEL ALUMNO
    listFilterPortal($('#portal-alumno-input-search') , $('.links-container'));
    function listFilterPortal(input, list) {
      $(input)
        .change(function() {
          var filter = quitAcentos($(this).val()).toLowerCase();
          $.each(list.find('li'), function(index, val) {
            var textName = $(this).children('a').text();
            textName = quitAcentos(textName).toLowerCase();
            if ( textName.search(filter) != -1 )  {
              $(this).show();
            } else {
              $(this).hide();
            }
          });
          // Una vez terminados los li comprobamos UL y títulos de sección
          checkVisibilidadColumnas(list, false);
          // Una vez terminado todo el proceso mostramos el mensaje "No encontrado" en caso necesario
          var numberBox = list.find('li').length;
            var numberBoxHidden = list.find('li:hidden').length;
            if(numberBox == numberBoxHidden){
              $('#textNotFound').show();
            }else{
              $('#textNotFound').hide();
            }
        })
        .keyup(function() {
          // fire the above change event after every letter
          $(this).change();
        });
    }
    /*Fin de script de buscador */

    //BUSCADOR PARA RECONOCIMIENTO DE CREDITOS
    listFilterReconocimientos($('#portal-reconocimientos-input-search') , $('.links-container'));
    function listFilterReconocimientos(input, list) {
      $(input)
        .change(function() {
          var filter = quitAcentos($(this).val()).toLowerCase();
          $.each(list.find('li'), function(index, val) {
            var textName = $(this).children('a, span').text();
            textName = quitAcentos(textName).toLowerCase();
            if ( textName.search(filter) != -1 )  {
              $(this).show();
            } else {
              $(this).hide();
            }
          });
          checkVisibilidadColumnas(list, true);
          var numberBox = list.find('li').length;
          var numberBoxHidden = list.find('li:hidden').length;
          if(numberBox == numberBoxHidden){
            $('#textNotFound').show();
          }else{
            $('#textNotFound').hide();
          }
        })
        .keyup(function() {
          // fire the above change event after every letter
          $(this).change();
        });
    }
    /*Fin de script de buscador */
    /*
    * list: (string) Contenedor del contenido donde buscar las listas
    * checkRows: (boolean) Indica si debemos buscar después en las filas completas.
    */
    function checkVisibilidadColumnas(list, checkRows){
      // Buscamos en todas las listas
      $.each(list.find('ul'),function(index){
        //console.log('lista número ' + index);
        // Contamos número de elementos cuyo atributo css display sea diferente de none.
        var visibles = $('li', this).filter(function() { return $(this).css("display") != "none" }).length;
        //console.log('elementos visibles ' + visibles);
        // Si visibles es 0 la lista está vacía. Ocultamos el ul y el H3 previo con el nombre de la titulación y debemos comprobar si todas los ul han quedado vacíos
        // en caso contrario ponemos todo visible
        if (visibles == 0){
            $(this).closest(".filter-content-column").attr('style','display: none!important');
            //$(this).prev().attr('style','display: none!important');
        }else{
            $(this).closest(".filter-content-column").attr('style','display: flex!important');
            //$(this).prev().attr('style','display: inline!important');
        }
      });
      if(checkRows){
        checkVisibilidadFilas(list);
      }
    }

    function checkVisibilidadFilas(list){
      // Buscamos en todas las filas
      $.each(list.find('.filter-content-row'),function(index){
        // Contamos número de columnas cuyo atributo css display sea diferente de none.
        var visibles = $('.filter-content-column', this).filter(function() { return $(this).css("display") != "none" }).length;
        // Si visibles es 0 todas las columnas están ocultas. Ocultamos toda la fila
        // en caso contrario ponemos todo visible
        if (visibles == 0){
            $(this).hide();
        }else{
            $(this).show();
        }
      });
    }

    function quitAcentos(str) {
      for (var i = 0; i < str.length; i++) {
        //Sustituye 'á é í ó ú'
        if (str.charAt(i) == 'á') str = str.replace(/á/, 'a');
        if (str.charAt(i) == 'é') str = str.replace(/é/, 'e');
        if (str.charAt(i) == 'í') str = str.replace(/í/, 'i');
        if (str.charAt(i) == 'ó') str = str.replace(/ó/, 'o');
        if (str.charAt(i) == 'ú') str = str.replace(/ú/, 'u');
      }
      return str;
    }

    /**
     * Control de visibilidad de filtros estudios
     */

    function init_filter_visibility() {

      if (($(window).width() <= 983) && ($('.filtros').is(':visible'))) {
        $('.filtros').hide();
        //console.log('hide filter');
      }

      if (($(window).width() > 983) && ($('.filtros').is(':hidden'))) {
        $('.filtros').show();
        //console.log('show filter');
      }

    }

    function set_body_overflow() {
      if ($('.filtros').is(':visible')) {
        $('body').addClass('body--blocked');
      } else {
        $('body').removeClass('body--blocked');
      }
    }

    init_filter_visibility();
    //breakpointChecker();

    $(window).resize(function() {
      init_filter_visibility();
      //breakpointChecker();
      //console.log($(window).width());
    });

    $('.js--control-filtros').click(function() {
      $('.filtros').toggle();
      set_body_overflow();
    });


    /**
     * Swipers
     */

    /*
        Inicialización de swiper para las tabs
     */




    new Swiper('.breadcrumb', {
      direction: 'horizontal',
      slidesPerView: 'auto',
      freeMode: true,
      mousewheel: true,
    });

    new Swiper('#swiper-instalaciones', {
      autoHeight: true, //enable auto height
      /*      navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
              hiddenClass: '.swiper-button-hidden',
              disabledClass: '.swiper-button-disabled'
    },*/
      slidesPerView: 1,
      spaceBetween: 1,
      loop: false,
      pagination: {
        el: '.swiper-pagination-instalaciones',
        clickable: true
      },
      loopFillGroupWithBlank: false,
      breakpoints: {
        320: {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 0,
        },
        600: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 0,
        },
        900: {
          slidesPerView: 3,
          slidesPerGroup: 1,
          spaceBetween: 0,
        }
      }
    });

    new Swiper('#swiper-estudios-relacionados', {
      autoHeight: true, //enable auto height
      slidesPerView: 1,
      spaceBetween: 1,
      loop: true,
      /*      navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
              hiddenClass: '.swiper-button-hidden',
              disabledClass: '.swiper-button-disabled'
    },*/
      loopFillGroupWithBlank: false,
      pagination: {
        el: '.swiper-pagination-estudios'
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        600: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 0,
        },
        900: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 0,
        },
        1200: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 0,
        },
      }
    });


    new Swiper('#swiper-masterclass', {
      autoHeight: true, //enable auto height
      slidesPerView: 1,
      spaceBetween: 1,
      loop: true,
      /*      navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
              hiddenClass: '.swiper-button-hidden',
              disabledClass: '.swiper-button-disabled'
    },*/
      loopFillGroupWithBlank: false,
      pagination: {
        el: '.swiper-pagination-masterclass'
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        600: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 0,
        },
        900: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 0,
        },
        1200: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 0,
        },
      }
    });


    /**
     * APERTURA DE ACORDEONES  POR URL
     */
    var $hash = location.hash;
    if ($hash && $hash[1]!="/") {
      $('.collapse.show').removeClass('show'); //cerramos todos los acordeones
      var $collapseItem = $($hash).addClass('show');
      $('html,body').animate({ scrollTop: $collapseItem.parent().offset().top }, 250);
    }

    var pattern = '/.*estudios\\/(grados|postgrados).*/';
    var regExp = new RegExp(pattern);
    if( $('.menu_estudios').length && regExp.test(document.referrer) ) {
      $('html,body').animate({ scrollTop: $('.menu_estudios').offset().top }, 0);
    }

    /**
     * Scroll down en icono de portada
     * */
    $('.scroll-icon').not('.scroll-icon-home').click(function(){
      $('html, body').animate({ scrollTop: $('.paragraph--type--estudio-ficha').offset().top} , 1000 );
    });

    /**
     * Buscador avanzado. Modificación de clases para aplicar efectos por CSS
     */
    $('#edit-search').focus(function(){
      $('.form-item-search').addClass('focus-active');
    });
    $('#edit-search').focusout(function(){
      if( $('#edit-search').val().length === 0 ) {
        $('.form-item-search').removeClass('focus-active');
      }
    });

    function checkInputOnLoad(){
      if( $('#edit-search').length && $('#edit-search').val().length > 0 ){
        $('.form-item-search').addClass('focus-active');
      }
    }

    checkInputOnLoad();

  });



})(jQuery, Drupal);
